<div class="indication-pme-container">
    <!-- Header Section -->
  <div class="header-section">
    <div class="header-content">
      <div class="header-text">
        <h1 class="page-title">{{ 'pages.indicationPme.title' | i18n }}</h1>

        <p class="page-subtitle">
          {{ 'pages.indicationPme.subtitle' | i18n }}
        </p>

        <p class="page-call-to-action">{{ 'pages.indicationPme.callToAction' | i18n }}</p>

        <ustore-button [textColor]="'var(--color-inverted)'" [size]="'medium'" [backgroundColor]="'var(--color-red-500-to-yellow)'"
          [text]="'pages.indicationPme.buttonStart' | i18n" [rounded]="'default'" (onClick)="onClick($event)"></ustore-button>
      </div>

      <div class="header-image mobile-hidden">
        <img src="assets/images/banners/indication.jpg" alt="Indication illustration" class="indication-image" />
      </div>
    </div>
  </div>

    <!-- Main Form -->
  <div class="form-section">
    <div class="form-container">
      <form [formGroup]="indicationPmeForm" (ngSubmit)="onSubmit($event)" class="indication-pme-form"
        novalidate="false">
                <!-- Company Information Section -->
        <div class="form-section-group">
          <h2 class="section-title company-info-title">
            <div class="step-number">1</div>
            {{ 'pages.indicationPme.section1.title' | i18n }}
          </h2>
          <div class="form-row">
            <div class="form-field">
              <label class="field-label" for="contactName">{{ 'pages.indicationPme.section1.contactName.label' | i18n }}</label>
              <umkt-custom-input
                id="contactName"
                type="text"
                class="input-custom"
                [error]="contactNameControl?.invalid && contactNameControl?.touched"
                [placeholder]="'pages.indicationPme.section1.contactName.placeholder' | i18n"
                formControlName="contactName"
                [maxlength]="255"
                required
                (keydown)="preventLeadingSpace($event)"
              />
              <span *ngIf="contactNameControl?.hasError('required') && contactNameControl?.touched" class="error-message">{{ 'shared.messages.required' | i18n }}</span>
              <div
                *ngIf="contactNameControl?.errors?.['noWhitespaceOnly'] && contactNameControl?.touched"
                class="error-message"
              >
                {{ 'pages.indicationPme.section1.contactName.errorWhitespace' | i18n }}
              </div>
              <div *ngIf="contactNameControl?.hasError('maxlength') && contactNameControl?.touched" class="field-error">
                {{ 'pages.indicationPme.section1.contactName.errorMax' | i18n }}
              </div>
            </div>
            <div class="form-field">
              <label class="field-label" for="companyName">{{ 'pages.indicationPme.section1.companyName.label' | i18n }}</label>
              <umkt-custom-input
                formControlName="companyName"
                id="companyName"
                class="input-custom"
                [ariaLabel]="'pages.indicationPme.section1.companyName.label' | i18n"
                [placeholder]="'pages.indicationPme.section1.companyName.placeholder' | i18n"
                [maxlength]="255"
                [error]="companyNameControl?.invalid && companyNameControl?.touched"
                (keydown)="preventLeadingSpace($event)"
              ></umkt-custom-input>
              <span *ngIf="companyNameControl?.hasError('required') && companyNameControl?.touched" class="error-message">{{ 'shared.messages.required' | i18n }}</span>
              <div *ngIf="companyNameControl?.hasError('maxlength') && companyNameControl?.touched" class="field-error">
                {{ 'pages.indicationPme.section1.companyName.errorMax' | i18n }}
              </div>
              <div
                *ngIf="companyNameControl?.errors?.['noWhitespaceOnly'] && companyNameControl?.touched"
                class="field-error"
              >
                {{ 'pages.indicationPme.section1.companyName.errorWhitespace' | i18n }}
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field">
              <label class="field-label" for="companyCNPJ">{{ 'pages.indicationPme.section1.cnpj.label' | i18n }}</label>
              <umkt-custom-input
                formControlName="companyCNPJ"
                id="companyCNPJ"
                [ariaLabel]="'pages.indicationPme.section1.cnpj.label' | i18n"
                [placeholder]="'pages.indicationPme.section1.cnpj.placeholder' | i18n"
                mask="AA.AAA.AAA/AAAA-00"
                class="input-custom"
                [error]="companyCNPJControl?.invalid && companyCNPJControl?.touched"
              ></umkt-custom-input>
              <span *ngIf="companyCNPJControl?.hasError('required') && companyCNPJControl?.touched" class="error-message">{{ 'shared.messages.required' | i18n }}</span>
              <div
                *ngIf="companyCNPJControl?.errors?.['invalidCNPJ'] && companyCNPJControl?.touched"
                class="field-error"
              >
                {{ 'pages.indicationPme.section1.cnpj.errorInvalid' | i18n }}
              </div>
            </div>

            <div class="form-field">
              <label class="field-label" for="companyPhone">{{ 'pages.indicationPme.section1.phone.label' | i18n }}</label>
              <umkt-custom-input
                id="companyPhone"
                type="tel"
                [error]="companyPhoneControl?.invalid && companyPhoneControl?.touched"
                [placeholder]="'pages.indicationPme.section1.phone.placeholder' | i18n"
                formControlName="companyPhone"
                class="input-custom"
                [maxlength]="15"
                (input)="applyPhoneMask($event)"
                (keydown)="onPhoneKeydown($event)"
                required
              ></umkt-custom-input>
              <span *ngIf="companyPhoneControl?.hasError('required') && companyPhoneControl?.touched" class="error-message">{{ 'shared.messages.required' | i18n }}</span>
              <div
                *ngIf="companyPhoneControl?.errors?.['invalidPhone'] && companyPhoneControl?.touched"
                class="error-message"
              >
                {{ 'pages.indicationPme.section1.phone.errorInvalid' | i18n }}
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field">
              <label class="field-label" for="companyEmail">{{ 'pages.indicationPme.section1.email.label' | i18n }}</label>
              <umkt-custom-input
                id="companyEmail"
                class="input-custom"
                type="email"
                [error]="companyEmailControl?.invalid && companyEmailControl?.touched"
                [placeholder]="'pages.indicationPme.section1.email.placeholder' | i18n"
                formControlName="companyEmail"
                (keydown)="preventLeadingSpace($event)"
                required
              ></umkt-custom-input>
              <span *ngIf="companyEmailControl?.hasError('required') && companyEmailControl?.touched" class="error-message">{{ 'shared.messages.required' | i18n }}</span>
              <div
                *ngIf="companyEmailControl?.errors?.['email'] && companyEmailControl?.touched"
                class="error-message"
              >
                {{ 'pages.indicationPme.section1.email.errorInvalid' | i18n }}
              </div>
              <div
                *ngIf="companyEmailControl?.errors?.['emailWithSpaces'] && companyEmailControl?.touched"
                class="error-message"
              >
                {{ 'pages.indicationPme.section1.email.errorSpaces' | i18n }}
              </div>
            </div>
          </div>
        </div>

                <!-- Form Actions -->
        <div class="form-actions right-align">
          <button type="submit" class="submit-btn" [disabled]="isSubmitting || indicationPmeForm.invalid"
            [ngClass]="{'disabled-btn': isSubmitting || indicationPmeForm.invalid}">
            <div *ngIf="isSubmitting">{{ 'pages.indicationPme.submittingButton' | i18n }}</div>
            <div *ngIf="!isSubmitting">{{ 'pages.indicationPme.submitButton' | i18n }}</div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>